export default __webpack_public_path__ + "static/media/download_light.22be2a83.svg";